import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class GetAllTrustedPortalActionsFetchError extends BaseEitherError {}

export type TGetAllTrustedPortalActionsOperationErrors = GetAllTrustedPortalActionsFetchError;
